import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
    const componentLocationCard = document.querySelectorAll('.component-location-cards__swiper'); // BEM class for the swiper container

    if (componentLocationCard.length === 0) return;

    componentLocationCard.forEach((componentLocationCardSwiper) => {
        
        const swipers = new Swiper(componentLocationCardSwiper, {
            loop: true,
            slidesPerView: 1.4,
            spaceBetween: 40,
            pagination: {
                el: componentLocationCardSwiper.querySelector('.swiper-pagination'),
                type: 'fraction', // This will display '1/2', '2/2', etc.
                clickable: true,
            },
            navigation: {
                nextEl: componentLocationCardSwiper.querySelector('.component-location-cards__button-next'), // BEM class for next button
                prevEl: componentLocationCardSwiper.querySelector('.component-location-cards__button-prev'), // BEM class for prev button
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    loopAddBlankSlides: true,
                },
            },
        });
    });
});
